import { getServiceUrl } from './api.config';
import { ApiClientOptions } from './types/api';
import ApiClient from './utils/ApiClient';
import {
  isBoolean,
  isNotEmptyArray,
  isNotEmptyString,
  isPositiveInteger,
} from './utils/validators';

export default class NotificationApi extends ApiClient {
  public constructor(options?: ApiClientOptions) {
    super(getServiceUrl('notification'), options);
  }

  public unreadCount(queries: any = {}, useCache: boolean = true) {
    const query = '/notification/v1/usernotifications/unreadcount';
    let parameters = '?alk=1';

    if (isBoolean(queries.onlyRolledOut)) {
      parameters += `&only_rolled_out=${queries.onlyRolledOut}`;
    }

    return this.get(query, parameters, useCache);
  }

  public list(
    queries: any = {},
    offset?: number,
    limit?: number,
    useCache: boolean = true,
  ) {
    const query = '/notification/v1/usernotifications';
    let parameters = '?alk=1';

    if (isNotEmptyString(queries.search)) {
      parameters += `&search=${queries.search}`;
    }
    if (isBoolean(queries.read)) {
      parameters += `&read=${queries.read}`;
    }
    if (isNotEmptyArray(queries.types)) {
      parameters += `&types=${queries.types.join()}`;
    }
    if (isNotEmptyArray(queries.statuses)) {
      parameters += `&statuses=${queries.statuses.join()}`;
    }
    if (isBoolean(queries.onlyRolledOut)) {
      parameters += `&only_rolled_out=${queries.onlyRolledOut}`;
    }
    if (isBoolean(queries.listSourceOrganizations)) {
      parameters += `&list_source_organizations=${queries.listSourceOrganizations}`;
    }
    if (isNotEmptyArray(queries.sourceOrganizationIdIn)) {
      parameters += `&source_organization_id_in=${queries.sourceOrganizationIdIn.join()}`;
    }
    if (isPositiveInteger(offset)) {
      parameters += `&offset=${offset}`;
    }
    if (isPositiveInteger(limit)) {
      parameters += `&limit=${limit}`;
    }

    return this.get(query, parameters, useCache);
  }

  public markAsRead(userNotificationIds: number[]) {
    const query = '/notification/v1/usernotifications/markasread';

    const body = { ids: userNotificationIds };

    return this.put(query, body);
  }

  public ignore(reference: string) {
    const query = `/notification/v1/usernotification/ignore`;
    return this.put(query, { reference });
  }

  public setStatus(
    notificationId: number,
    status: any,
    onlyForMe: boolean = false,
  ) {
    const query = `/notification/v1/notifications/${notificationId}/setstatus`;

    const body = { status, only_for_me: onlyForMe };

    return this.put(query, body);
  }

  public unsubscribe(token: any, event: any = null) {
    const query = '/notification/v1/usersubscriptions/unsubscribe';
    return this.put(query, { token, event });
  }

  public promoteProducts(emails: string[], message: any) {
    const query = '/notification/v1/products/promote';
    return this.post(query, { emails, message });
  }
}
